import { render, staticRenderFns } from "./About.vue?vue&type=template&id=4b05cc7a&scoped=true&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b05cc7a",
  null
  
)

component.options.__file = "About.vue"
export default component.exports